__turbopack_context__.v({
  "chat": "maintenance-screen-module-scss-module__ycxHGG__chat",
  "chat-contact": "maintenance-screen-module-scss-module__ycxHGG__chat-contact",
  "chat-txt": "maintenance-screen-module-scss-module__ycxHGG__chat-txt",
  "container": "maintenance-screen-module-scss-module__ycxHGG__container",
  "footer": "maintenance-screen-module-scss-module__ycxHGG__footer",
  "icon-txt": "maintenance-screen-module-scss-module__ycxHGG__icon-txt",
  "logo": "maintenance-screen-module-scss-module__ycxHGG__logo",
  "title": "maintenance-screen-module-scss-module__ycxHGG__title",
});
